export const publicPaths = [
  "/public",
  "/open",
  "/apps/company/sign-in-and-attach",
  "/apps/company/create",
];
